export default __webpack_public_path__ + "static/media/home.be78d109.svg";